<template>
  <section class="pb-[7rem]">
    <div class="container-lg">

      <div class="section__header text-center">
        <h1 class="mt-[48px] text-heading-1 ">
          {{ splitTitle.first }}
          <span :class="['text-lime-green ']">
            {{ splitTitle.last }}
          </span>
        </h1>
        <!-- progress bar -->
        <div v-if="false" class="my-[32px] w-full">
          <span class="text-[16px] font-light text-medium-gray" v-html="formattedText">
          </span>
          <div  class="w-[90%] sm:w-[70%] md:w-[50%] lg:w-1/3 mx-auto h-[8px] rounded-full bg-[#E5E5E5] mt-[26px] relative">
            <div :style="{ width: `${percentUntilFreeDelivery}%` }" class="relative h-full left-0 top-0 rounded-full bg-lime-green transition-all duration-500">
              <div class="absolute -right-[16px] -top-[12px] bottom-0 bg-lime-green w-[32px] h-[32px] rounded-full flex items-center justify-center">
                <img src="/shop/images/delivery-moving.svg" alt="icon">
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="isNotEmptyCart()" class="row">
        <div class="w-full">
          <CartItemsList
            :cart="cart"
            :in18="in18"
            @update-cart="updateCart"
          />
          <template v-if="services.length">
            <Services
              :cart="cart"
              :in-progress="inProgress"
              :in18="in18"
              :services="services"
              @update-cart="updateCart"
              @update-in-progress="updateInProgress"
            />
          </template>
        </div>
        <div class="w-full">
          <!--
          <CartShipping
            :in18="in18"
            :cart="cart"
            :in-progress="inProgress"
            @update-cart="updateCart"
            @update-in-progress="updateInProgress"
          />
          -->
          <div class="flex flex-col md:flex-row gap-[24px] lg:gap-[64px] pt-[32px] pb-[56px]">

            <div class="flex flex-col gap-[40px]">
              <div class="text-left">
                <span class="text-[20px] leading-[28px] font-medium">
                  {{ in18['page_cart_delivery_option'] }}
                </span>
                <ul class="flex flex-col lg:flex-row gap-[12px] mt-[16px] mb-[12px]">
                  <li v-for="shipping_delivery_day in cart.shipping_delivery_days" class="flex-1 p-[16px] flex flex-col border border-light-gray/25 rounded-[8px]">
                    <img class="w-[24px] h-[24px] mb-[8px]" :src="shipping_delivery_day.icon" :alt="shipping_delivery_day.title">
                    <div class="delivery-options__title mb-4">
                      {{ shipping_delivery_day.title }}
                    </div>
                    <div class="delivery-options__text">
                      <div v-html="shipping_delivery_day.days"></div>
                      <div v-html="shipping_delivery_day.price"></div>
                    </div>
                  </li>
                </ul>
                <div class="text-sm text-gray">{{ in18['page_estimated_delivery_dates_message'] }}</div>
              </div>

              <CartCoupon
                class="w-2/3"
                :cart="cart"
                :in-progress="inProgress"
                :in18="in18"
                @update-cart="updateCart"
                @update-in-progress="updateInProgress"
              />
            </div>
            <div class="w-full md:w-[50%] lg:w-[45%]">
              <CartSummary
                class=""
                :cart="cart"
                :checkout_route="checkout_route"
                :in18="in18"
              />
            </div>
          </div>

          

        </div>
      </div>
      <div v-else class="row">
        <div v-if="!inProgress" class="d-flex justify-content-center ml-4">
          <div>
            <img
              alt=""
              class="img m-auto mb-4"
              src="/shop/images/cart_empty.png"
              style="width: 80px;"
            />
            <div class="section__text text-center mb-2">
              {{ in18['page_cart_is_empty'] }}
            </div>
            <a class="btn btn--green btn--block btn--sm" href="/">
              {{ in18['page_continue_shopping_btn'] }}
            </a>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { ref, computed } from 'vue';
import axios from 'axios';

import CartCoupon from '../components/cart/CartCoupon.vue';
import CartItemsList from '../components/cart/CartItemsList.vue';
import CartSummary from '../components/cart/CartSummary.vue';
import CartShipping from '../components/cart/CartShipping.vue';
import Services from '../components/cart/Services.vue';

const props = defineProps({
  in18: {
    type: Object,
    required: true,
  },
  checkout_route: {
    type: String,
    required: true,
  },
});

const inProgress = ref(true);
const cart = ref({});
const services = ref([]);
const freeDeliveryTarget = 100

const percentUntilFreeDelivery = computed(() => {
  const percent = Math.min(100, (cart.value.total_price / freeDeliveryTarget) * 100) || 0
  return percent
})

const splitTitle = (string) => {
  if (!string) return {};
  const words = string.split(" ");
  const last = words.pop();
  return {
    first: words.join(" "),
    last,
  };
};

const formattedText = computed(() => {
  const template = props.in18['page_cart_amount_until_free_delivery'];
  const delivery = props.in18['page_cart_free'];

  const targetReached = cart.value.total_price >= freeDeliveryTarget

  if(targetReached) {
    return props.in18['page_cart_free_delivery_goal_reached'].replace('{delivery}', `<b class="font-bold">${delivery}</b>`);
  }

  const difference = freeDeliveryTarget - cart.value.total_price;
  const amount = difference || 0
  return template
    .replace('{amount}', `<b class="font-bold">${amount + '€'}</b>`)
    .replace('{delivery}', `<b class="font-bold">${delivery}</b>`);
});

function fetchCart() {
  axios
    .get('/api/cart/reset-data')
    .then((response) => {
      cart.value = response.data.cart;
      ga_view_cart_event(response.data.cart);
    })
    .catch((error) => {
      window.toastr.error(error.response.data.message);
    })
    .finally(() => {
      inProgress.value = false;
    });
}

function fetchServices() {
  axios
    .get('/api/product/services')
    .then((response) => {
      services.value = response.data;
    })
    .catch((error) => {
      window.toastr.error(error.response.data.message);
    })
    .finally(() => {
      inProgress.value = false;
    });
}

fetchServices();
fetchCart();

function updateCart(newCart) {
  cart.value = newCart;
}

function updateInProgress(val) {
  inProgress.value = val;
}

function isNotEmptyCart() {
  return (
    cart.value.hasOwnProperty('items') &&
    cart.value.items.length > cart.value.item_services.length
  );
}
</script>
